<div class="row">
  <div class="col-10">
    <nav class="navbar navbar-expand-lg ">
      <img class="bcbsri-image" src="../../assets/images/bcbsri-new.PNG" alt="logo2">
    </nav>
  </div>
  <!-- <div class="col-2 mainlogout">
      <a class="logout">Logout</a>
  </div> -->
</div>

<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <a class="navbar-brand" href="#"></a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
          aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarNav">
    <ul class="navbar-nav">
      <li class="nav-item" routerLinkActive="active">
        <a class="nav-link paddingFromApp" routerLink="/landing">
          Home <span class="sr-only">(current)</span>
        </a>
      </li>
      <li class="nav-item" routerLinkActive="active">
        <a class="nav-link" routerLink="/started">Getting Started</a>
      </li>
      <li class="nav-item" routerLinkActive="active">
        <a class="nav-link" routerLink="/resources">Resources</a>
      </li>
    </ul>
  </div>
</nav>

<br>
<br>

<div class="container">
  <div class=WordSection1 style="font-family: 'BentonSans-Light';">

    <h1 style="color:#007bff;">Getting Started</h1>

    <p class=MsoNormal>&nbsp;</p>

    <p class=MsoNormal>
      <span style='font-size:20.0pt;line-height:107%;color:#007bff;'>
        CMS
        Interoperability API Developer Portal
      </span>
    </p>

    <p class=MsoNormal style='line-height:normal;vertical-align:top'>
      The CMS
      Interoperability API Developer Portal provides third-party app developers with
      access to documentation, Account Management, Application Management, Portal
      Services and other developer services related to application programming
      interfaces (“APIs”) provided by CMS pursuant to the Centers for Medicare &amp;
      Medicaid Services (“CMS”) Interoperability and Patient Access Final Rule
    </p>

    <p class=MsoNormal style='line-height:normal;vertical-align:top'>
      Once services
      are live:
    </p>

    <ul type=disc>
      <li class=MsoNormal style='line-height:normal;vertical-align:top'>
        The Patient
        Access API will allow developers to retrieve, with the approval and at the
        direction of an applicable CMS Developer Portal enrollee or the enrollee’s
        personal representative, certain data, as applicable, concerning
        adjudicated claims, encounter data from capitated providers, formulary
        data, and certain clinical data, if CMS maintains any such data.
      </li>
      <li class=MsoNormal style='line-height:normal;vertical-align:top'>
        The Patient Access API’s
        will fetch the data from FHIR server
      </li>
    </ul>

    <p class=MsoNormal>
      <span style='font-size:20.0pt;line-height:107%;color:#007bff;'>
        Registering
        as a Developer for CMS APIs
      </span>
    </p>

    <p style='margin-top:0in;vertical-align:top'>
      How to create an account to use
      CMS Interoperability API Developer Portal if you are a DEVELOPER:
    </p>

    <ul type=disc>
      <li class=MsoNormal style='line-height:normal;vertical-align:top'>
        Click
        on&nbsp;Login/Register and click on Register
      </li>
      <li class=MsoNormal style='line-height:normal;vertical-align:top'>
        User would be providing following information at the time of
        registration.
      </li>
      <br>

      <p class=MsoListParagraphCxSpMiddle style='margin-top:0in;margin-right:0in;
        margin-bottom:0in;margin-left:1.0in;text-align:justify;text-indent:-.25in;
        line-height:normal'>
        <span style='font-size:10.0pt;'>
          o<span style='font:7.0pt ""'>&nbsp;&nbsp;&nbsp; </span>
        </span>Name
      </p>

      <p class=MsoListParagraphCxSpMiddle style='margin-top:0in;margin-right:0in;
        margin-bottom:0in;margin-left:1.0in;text-align:justify;text-indent:-.25in;
        line-height:normal'>
        <span style='font-size:10.0pt;'>
          o<span style='font:7.0pt ""'>&nbsp;&nbsp;&nbsp; </span>
        </span>Email
      </p>

      <p class=MsoListParagraphCxSpMiddle style='margin-top:0in;margin-right:0in;
        margin-bottom:0in;margin-left:1.0in;text-align:justify;text-indent:-.25in;
        line-height:normal'>
        <span style='font-size:10.0pt;'>
          o<span style='font:7.0pt ""'>&nbsp;&nbsp;&nbsp; </span>
        </span>Address
      </p>

      <p class=MsoListParagraphCxSpMiddle style='margin-top:0in;margin-right:0in;
        margin-bottom:0in;margin-left:1.0in;text-align:justify;text-indent:-.25in;
        line-height:normal'>
        <span style='font-size:10.0pt;'>
          o<span style='font:7.0pt ""'>&nbsp;&nbsp;&nbsp; </span>
        </span>Phone
      </p>

      <p class=MsoListParagraphCxSpMiddle style='margin-top:0in;margin-right:0in;
        margin-bottom:0in;margin-left:1.0in;text-align:justify;text-indent:-.25in;
        line-height:normal'>
        <span style='font-size:10.0pt;'>
          o<span style='font:7.0pt ""'>&nbsp;&nbsp;&nbsp; </span>
        </span>Organization
        Information
      </p>
      <ul style="list-style-type:square; margin-left: 100px;">
        <li>Organization Name</li>

        <li>Organization Tax ID</li>
        <li>Organization Address</li>
        <li>Alternate Email Address</li>
        <li>Privacy Policy (Y/N)</li>
        <li>Information Security Policy (Y/N)</li>
        <li>Organization Privacy Policy URL</li>
        <li>Infosec questionnaire</li>
      </ul>
      <p class=MsoListParagraphCxSpMiddle style='margin-top:0in;margin-right:0in;
        margin-bottom:0in;margin-left:1.0in;text-align:justify;text-indent:-.25in;
        line-height:normal'>
        <span style='font-size:10.0pt;'>
          o<span style='font:7.0pt ""'>&nbsp;&nbsp;&nbsp; </span>
        </span>Acknowledgement
        of BCBSRI Terms and Conditions
      </p>

      <p class=MsoListParagraphCxSpMiddle style='margin-top:0in;margin-right:0in;
        margin-bottom:0in;margin-left:1.0in;text-align:justify;text-indent:-.25in;
        line-height:normal'>
        <span style='font-size:10.0pt;'>
          o<span style='font:7.0pt ""'>&nbsp;&nbsp;&nbsp; </span>
        </span>Acknowledgement
        of BCBSRI Code of Conduct
      </p>
    </ul>

    <ul type=disc>
      <li class=MsoNormal style='line-height:normal;vertical-align:top'>
        Once the user has their email validated and acknowledged the
        Terms and Condition &amp; Code of Conduct. The user account would get created
        immediately with active status.
      </li>
      <li class=MsoNormal style='line-height:normal;vertical-align:top'>
        CMS will
        email a security code to your email address. Check your email and enter
        the code. The code will expire after 5 minutes.
      </li>
      <li class=MsoNormal style='line-height:normal;vertical-align:top'>
        Create a
        username
      </li>
      <li class=MsoNormal style='line-height:normal;vertical-align:top'>
        Create a
        password, then re-enter your password
      </li>
    </ul>

    <p class=MsoNormal>
      <span style='font-size:20.0pt;line-height:107%;color:#007bff;'>
        Subscribing
        to CMS APIs
      </span>
    </p>

    <ul style='margin-top:0in' type=disc>
      <li class=MsoNormal style='margin-bottom:0in;line-height:normal;vertical-align:
         top'>Click on App Register, then Create New.</li>
      <li class=MsoNormal style='margin-bottom:0in;line-height:normal;vertical-align:
         top'>
        Authenticated &amp; active user would be able to create new
        Application registration via the Developer Portal. Usage
        (Non-Production/Production), Application Name, Purpose &amp; Details of the
        Application, Redirect URL, Application Logo information is collected at
        the time of App creation.
      </li>
      <li class=MsoNormal style='margin-bottom:0in;line-height:normal;vertical-align:
         top'>
        Application details submitted register the application in the
        solution immediately. Post registration, a unique Client ID and Client
        Secret would be shared to the user on the post Application creation
        screen.
      </li>
      <li class=MsoNormal style='margin-bottom:0in;line-height:normal;vertical-align:
         top'>
        Click on My Applications again and click refresh to see your new
        application.
      </li>
      <li class=MsoNormal style='margin-bottom:0in;line-height:normal;vertical-align:
         top'>
        Authenticated &amp; active user would be able to manage all the
        applications for the organization. They would be able to request for new
        Client Secret. Or Edit the application details, and same application
        validations would be applied.
      </li>
      <li class=MsoNormal style='margin-bottom:0in;line-height:normal;vertical-align:
         top'>
        Authenticated &amp; active user should be able to delete an
        application. This would be treated internally as an application deactivation
        (Soft delete). All the consents associated with the application would be
        deleted.
      </li>
      <p>
        <u>Note:</u> <i>
          If the
          usage is Production and if there is a change in Redirect URI, then all the
          consents associated with the application would be deleted.
        </i>
      </p>
    </ul>
  </div>
</div>
